import * as React from 'react';
import OEITable from './OEITable';
import { ValidateEmail, doNothing } from './OEIUtils';
import { createAccountAPI, fetchAllAccountData, createNewAccout, editAccountdata, deleteAccount } from './APIService';
import { useEffect } from 'react';
import { CLIENT_NAME, EMPTY, LOADING } from './Constants';
export default function BasicTable(props) {
  const [accounts, setAccounts] = React.useState([])
  const [generate, setGenerate] = React.useState('true');
  const [newAccountData, setnewAccountData] = React.useState({ clientName: EMPTY, clientId: EMPTY, description: EMPTY });
  const [closePopover, setClosePopover] = React.useState(true);
  const [message, setMessage] = React.useState(LOADING);
  const [errors, setErrors] = React.useState({ error1: EMPTY, error2: EMPTY, error3: EMPTY });
  useEffect(function () {
    fetchTableData();
  }, [])
  const fetchTableData = () => {
    fetchAllAccountData().then(response => {
      response.length === 0 ? setMessage('There are no accounts mapped') : setMessage(EMPTY)
      setAccounts(response);
    })
  };

  const createAccount = () => {

    if (validateData(newAccountData, newAccountData.clientId)) {
      createNewAccout(newAccountData).then(respose => {
        fetchTableData();
        setClosePopover(true);
        setnewAccountData({ clientName: EMPTY, clientId: EMPTY, description: EMPTY })
        setGenerate(true);
      })
    }
  };
  const handleManageAcct = (integrationAcctId) => {
    props.history.push(`/accounts/accountmapping/${integrationAcctId}`);
  };
  const columns = [
    { id: CLIENT_NAME, label: 'Account Name', align: 'left', edit: true, width: '10%', button: false },
    { id: 'integrationAcctId', label: 'Integration Account ID', button: false, edit: false, width: '10%' },
    { id: 'clientUserId', label: 'User ID/API Key', button: false, edit: false, width: '15%' },
    { id: 'organization', label: 'Organization', button: false, edit: false, width: '15%' },
    { id: 'contactEmail', label: 'Contact Email', button: false, edit: false, width: '10%' },
    { id: 'Manage', label: EMPTY,buttonLabel:'Manage', button: true, edit: false, width: '30%',align: 'right', disable: true }
  ];
  const getAccounts = () => {
    const newArr = accounts.map((element, index) => {
      return { ...element, id: element.integrationAcctId };
    });
    return newArr;
  }


  function validateData(data, clientEmail) {
    var errorList = [];
    if (data.clientName === EMPTY) {
      errorList = { ...errorList, error1: "Account Name is required" }
    } else if (data.clientName.length > 255) {
      errorList = ({ ...errorList, error1: 'Account Name length should be less than 255 characters' })
    } if (clientEmail === EMPTY) {
      errorList = ({ ...errorList, error2: 'API Client ID is required' });
    } else if (!ValidateEmail(clientEmail)) {
      errorList = ({ ...errorList, error2: "Please enter valid emailId" });
    } if (data.description === EMPTY) {
      errorList = ({ ...errorList, error3: "Description is required" });
    } else if (data.description.length > 4096) {
      errorList = ({ ...errorList, error3: 'Description length should be less than 4096 characters' });
    } if (data.contactEmail === EMPTY) {
      errorList = ({ ...errorList, error4: 'Contact Email is required' });
    } else if (!ValidateEmail(data.contactEmail)) {
      errorList = ({ ...errorList, error4: "Please enter valid emailId" });
    } else if (data.contactEmail.length > 255) {
      errorList = ({ ...errorList, error4: 'Contact Email length should be less than 255 characters' })
    }
    if (data.organization === EMPTY) {
      errorList = { ...errorList, error5: "organization Name is required" }
    } else if (data.organization.length > 255) {
      errorList = ({ ...errorList, error5: 'organization Name length should be less than 255 characters' })
    } 
    setErrors({ ...errorList })
    return errorList.length === 0;
  }

  function handleClickGenerate() {
    if (validateData(newAccountData, newAccountData.clientId)) {
      createAccountAPI(newAccountData).then(data => {
        if (data.message === "An account with the given email already exists.") {
          setErrors({ ...errors, error2: "An account with the given email already exists." });
          setGenerate(true);
        } else {
          setnewAccountData({ ...newAccountData, clientSecret: data.clientSecret, integrationAccountId: data.integrationAccountId });
          setGenerate(false);
        }
      });
    }
  }

  const editAccount = (row) => {

    if (row.description === undefined) {
      row.description = EMPTY;
    }
    if (row.organization === undefined) {
      row.organization = EMPTY;
    } if (row.contactEmail === undefined) {
      row.contactEmail = EMPTY;
    }
    if (validateData(row, row.clientUserId)) {
      setClosePopover(true);
      editAccountdata(row).then(data => {
        fetchTableData();
      })
    }
  }
  const deleteAccountData = (e) => {
    deleteAccount(e.integrationAcctId).then(response => {
      setClosePopover(true)
      fetchTableData();
    })
  }
  return (
    <>
      <OEITable removeMainItem={doNothing}delete={deleteAccountData} headerStyle='sticky-header' tableHeaderStyle='table-header' setSystemName={doNothing}
        edit={editAccount} closePopover={closePopover} setClosePopover={setClosePopover} errors={errors} setErrors={setErrors}
        onclick={createAccount} setGenerate={setGenerate} generate={generate} columns={columns}
        setEmail={doNothing} handleManageAcct={handleManageAcct} tableHeadings='Accounts'
        setNewData={setnewAccountData} newAction='Account' handleClickGenerate={handleClickGenerate}
        newData={newAccountData} rowData={getAccounts()} message={message} filterField={'clientName'}></OEITable>
    </>
  );
}